
import React from 'react';
import HomeSection from '../page-sections/home-section';
import AboutusSection from '../page-sections/aboutus-section';
import ServicesSection from '../page-sections/services-section';
import ExpertiseSection from '../page-sections/expertise-section';
import OurProductsSection from '../page-sections/our-products-section';
import OurClientsSection from '../page-sections/our-clients-section';

function HomePage() {
    return (
        <>
            <HomeSection />
            <AboutusSection />
            <ServicesSection />
            <OurProductsSection />
            <OurClientsSection />
            <ExpertiseSection />
        </>
    );
}

export default HomePage;
